module.exports = __webpack_public_path__ + "img/geoportal.71c9cdd3.png";